var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-10",
                  attrs: { "lazy-validation": "" }
                },
                [
                  _c(
                    "v-container",
                    {
                      staticStyle: { padding: "30px 40px 50px 40px" },
                      attrs: { "grid-list-md": "" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "boton_crear" },
                        [
                          _vm.formFields.serienumero.value !== "(Sin datos)"
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "icon",
                                  staticStyle: {
                                    "background-color": "rgb(255, 108, 0)",
                                    "border-color": "rgb(255, 108, 0)",
                                    "padding-right": "20px",
                                    display: "block",
                                    margin: "0 0 0 auto"
                                  },
                                  on: { click: _vm.editar }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "color-blanco",
                                      staticStyle: { color: "white" }
                                    },
                                    [_vm._v("Guardar")]
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Equipo Activado" } },
                        [
                          _vm._t("prependInformacionGeneral"),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.serienumero.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.serienumero.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.serienumero,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.serienumero.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.tipoeqname.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.tipoeqname.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.tipoeqname,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.tipoeqname.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.epc.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.epc.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.epc, "value", $$v)
                                  },
                                  expression: "formFields.epc.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label:
                                    _vm.formFields.serieactivafecha_alta.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value:
                                    _vm.formFields.serieactivafecha_alta.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.serieactivafecha_alta,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.serieactivafecha_alta.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label:
                                    _vm.formFields.serieactivaes_arriendo.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value:
                                    _vm.formFields.serieactivaes_arriendo.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.serieactivaes_arriendo,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.serieactivaes_arriendo.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.asigrequerimiento.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.asigrequerimiento.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.asigrequerimiento,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.asigrequerimiento.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.asigcrm_rutcli.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.asigcrm_rutcli.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.asigcrm_rutcli,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.asigcrm_rutcli.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", sm6: "", md: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.asigcrm_cliente.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.asigcrm_cliente.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.asigcrm_cliente,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.asigcrm_cliente.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.asigcrm_flota.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.asigcrm_flota.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.asigcrm_flota,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.asigcrm_flota.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.plataforma.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.plataforma.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.plataforma,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.plataforma.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", sm6: "", md6: "" } },
                            [
                              _vm.formFields.serieactivaplata_ingresada.value ==
                              "S"
                                ? _c("v-checkbox", {
                                    attrs: {
                                      label:
                                        _vm.formFields
                                          .serieactivaplata_ingresada.label,
                                      "true-value": "S",
                                      "false-value": "N"
                                    },
                                    model: {
                                      value:
                                        _vm.formFields
                                          .serieactivaplata_ingresada.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields
                                            .serieactivaplata_ingresada,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formFields.serieactivaplata_ingresada.value"
                                    }
                                  })
                                : _vm._e(),
                              _vm.formFields.serieactivaplata_ingresada.value ==
                              "N"
                                ? _c("v-checkbox", {
                                    attrs: {
                                      label:
                                        _vm.formFields
                                          .serieactivaplata_ingresada.label,
                                      "true-value": "S",
                                      "false-value": "N"
                                    },
                                    model: {
                                      value:
                                        _vm.formFields
                                          .serieactivaplata_ingresada.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields
                                            .serieactivaplata_ingresada,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formFields.serieactivaplata_ingresada.value"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label:
                                    _vm.formFields.serieactivaplata_fecha.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value:
                                    _vm.formFields.serieactivaplata_fecha.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.serieactivaplata_fecha,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.serieactivaplata_fecha.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label:
                                    _vm.formFields.serieactivaid_dispositivo
                                      .label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value:
                                    _vm.formFields.serieactivaid_dispositivo
                                      .value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.serieactivaid_dispositivo,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.serieactivaid_dispositivo.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.serieactivaavl.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.serieactivaavl.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.serieactivaavl,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.serieactivaavl.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label:
                                    _vm.formFields.serieactivafecha_instala
                                      .label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value:
                                    _vm.formFields.serieactivafecha_instala
                                      .value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.serieactivafecha_instala,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.serieactivafecha_instala.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.patente_vehiculo.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.patente_vehiculo.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.patente_vehiculo,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.patente_vehiculo.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label:
                                    _vm.formFields.serieactivafecha_baja.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value:
                                    _vm.formFields.serieactivafecha_baja.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.serieactivafecha_baja,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.serieactivafecha_baja.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.serieactivaobs.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.serieactivaobs.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.serieactivaobs,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.serieactivaobs.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }